import { Route, Routes } from "react-router-dom";
import { Space } from "~/lib/types";
import WorkspacesEntryPage from "~/entry-pages/space/workspaces/WorkspacesEntryPage";
import CreateWorkspaceEntryPage from "~/entry-pages/space/workspaces/new/CreateWorkspaceEntryPage";

export type WorkspaceRoutesProps = {
  space: Space;
};

export function WorkspaceRoutes({ space }: WorkspaceRoutesProps) {
  return (
    <Routes>
      <Route index element={<WorkspacesEntryPage {...{ space }} />} />
      <Route path="new" element={<CreateWorkspaceEntryPage />} />
    </Routes>
  );
}
